import "./BannerText.css";

const BannerText = () => {
  return (
    <div class="sign">
      {/* <span class="fast-flicker">H</span>ack<span class="flicker">O</span>ver
      <span class="fast-flicker">f</span>
      <span class="flicker">low</span>4.0 */}
      HackOverflow 4.0
    </div>
  );
};
export default BannerText;
